module.exports = __webpack_public_path__ + "img/Master-1.461f5a92.gif";